import "./template/styles";
import React from "react";
import Routing from "./routes/Routes";
import Alerts from "@common/Alerts";
import Preloader from "@common/Preloader";
import Modals from "@/components/modals";
import { Provider } from "react-redux";
import store from "@store/redux.store";
import { ConfigProvider } from "antd";
import locale from "antd/es/locale/ru_RU";
import "dayjs/locale/ru";
import { useScreenWidth } from "@hooks/useScreenWidth";
import Confirm from "./components/UI/Confirm/Confirm";
import { setTitleAndDescription } from './helpers/new/setTitleAndDescription'
import { BrowserRouter } from "react-router-dom";
import { API } from "./api";
import { useNativeHoverTitles } from "@hooks/useNativeHoverTitles";
import { useThemeMode } from "@hooks/useThemeMode";
import { usePlatformThemeColors } from "@hooks/usePlatformThemeColors";
import MeetingIframe from '@common/MeetingIframe';
import PlatformFavicon from '@/components/common/PlatformFavicon';

const App = () => {
  const isMobile = useScreenWidth(992);
  useNativeHoverTitles();
  const { theme: themeMode, isDarkTheme } = useThemeMode();
  const platformColors = usePlatformThemeColors(themeMode);

  API.get('/setting/get-app-name')
    .then((res) => {
      setTitleAndDescription({title: res?.data})
    })

  const theme = {
    token: {
      colorPrimary: platformColors["--color-accent"],
      colorLink: "inherit",
      fontFamily: `Montserrat, -apple-system`,
      borderRadius: isMobile ? 12 : 16,
      controlHeight: isMobile ? 42 : 54,
      colorBgContainer: platformColors["--color-surface"],
      colorBgElevated: isDarkTheme
        ? platformColors["--color-surface-soft"]
        : platformColors["--color-surface"],
      colorText: platformColors["--color-text-main"],
      colorTextSecondary: platformColors["--color-text-secondary"],
      colorBorder: platformColors["--color-light-stroke"],
    },
  };

  return (
    <Provider {...{ store }}>
      <PlatformFavicon />
      <ConfigProvider {...{ locale, theme }}>
        <BrowserRouter>
          <Preloader />
          <Alerts />
          <Modals />
          <MeetingIframe />
          <Confirm />
          <Routing />
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
